import { UserRole } from "types/user";

export interface IMenuItem {
  label: string;
  link: string;
  validRoles?: UserRole[];
}

export const MenuItems: IMenuItem[] = [
  { label: "My Account", link: "/dashboard/account" },
  { label: "Preferences", link: "/dashboard/preferences" },
  { label: "Draft Custom Panels", link: "/dashboard/draft-custom-panels" },
  {
    label: "Users",
    link: "/dashboard/users",
    validRoles: [UserRole.SalesRep, UserRole.Admin],
  },
  { label: "Quote History", link: "/dashboard/quotes" },
  {
    label: "Designs",
    link: "/dashboard/designs",
    validRoles: [UserRole.Admin],
  },
];
